import { useState } from "react"
import logoImage from "../../assest/images/logo-img.png"
import prularo from "../../assest/myImages/PLURALO_LOGO_WEBSITE.png"
import { Link } from "react-router-dom"
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles"
import helper, { CountrySelectoptions2, ProviderSelectoptions2 } from "../../common/Helper";
import "flag-icons/css/flag-icons.min.css";
import Select2 from 'react-select2-wrapper';
import 'react-select2-wrapper/css/select2.css';
import ProviderList from "../../components/ProviderList"
import "../../assest/css/login.css"
import "../../assest/css/signup.css"
import ProviderRegisterModal from "./ProviderRegisterModal"
import bokunLogo from "../../assest/myImages/Bokun-Logo-_-Dark.webp"
import fareharborLogo from "../../assest/myImages/fareharbor-logo.svg"
import turitopLogo from "../../assest/myImages/Logo_TuriTop.svg"

const platformProviders = [
    { name: 'Bokun', value: 'Bokun', logo: bokunLogo },
    { name: 'FareHarbor', value: 'Fareharbor', logo: fareharborLogo, large: true },
    { name: 'Pluralo', value: 'Pluralo', logo: prularo, darkLogo: true },
    { name: 'Turitop', value: 'Turitop', logo: turitopLogo },
];

const Index = ({
    state,
    register,
    changeValue,
    showPassword, showCPassword,
    handhandleShowPassword,
    inputRef,
    getClassNames,
    isLoading,
    handleNumberChange,
    handleValidityChange,
    selectedCountryOption,
    selectedTourProviderOption,
    isOtherProvider,
    isNoProvider,
    handleCountrySelectChange,
    handleTourProviderSelectChange,
}) => {
    const [showManual, setShowManual] = useState(false);
    const [registerProvider, setRegisterProvider] = useState('');
    const { first_name, last_name, error, email, password, cpassword, legal_company_name, other_provider_name } = state;

    return (

        <div className="sq-wrapper sq-signup">
            <div className="sq-left">
                <a href={helper.touristUrl} target="_blank"><img src={logoImage} alt="logo-img" className="logo-img" /></a>
                <div className="sq-form-section">
                    <h1 className="sq-heading">Join Toursxplorer.com</h1>
                    <p className="sq-subheading">Create your supplier account and start reaching more travelers.</p>

                    {!showManual && <div className="su-card">
                        <div className="su-card-head">
                            <span className="su-step">1</span>
                            <div>
                                <div className="su-card-title">Register with your booking platform</div>
                                <div className="su-card-desc">Connect your existing account to automatically import your tours, availability and more.</div>
                            </div>
                        </div>
                        <div className="su-providers">
                            {platformProviders.map((p) => (
                                <button
                                    key={p.value}
                                    type="button"
                                    className={`su-provider ${selectedTourProviderOption === p.value ? 'active' : ''}`}
                                    onClick={() => setRegisterProvider(p.value.toLowerCase())}
                                >
                                    <span className={`su-provider-logo ${p.darkLogo ? 'dark' : ''} ${p.large ? 'large' : ''}`}>
                                        {p.logo ? <img src={p.logo} alt={p.name} /> : <span className="su-provider-name">{p.name}</span>}
                                    </span>
                                    <span className="su-provider-label">Register with {p.name}</span>
                                    <i className="fa-solid fa-chevron-right"></i>
                                </button>
                            ))}
                        </div>
                    </div>}

                    <div className="su-manual-link">
                        {!showManual ? (
                            <a href="#manual" onClick={(e) => { e.preventDefault(); setShowManual(true); }}>I don't use any of the above providers</a>
                        ) : (
                            <a href="#platform" onClick={(e) => { e.preventDefault(); setShowManual(false); }}>
                                <i className="fa-solid fa-arrow-left"></i> Register with your booking platform
                            </a>
                        )}
                    </div>

                    {showManual && <form onSubmit={register}>
                        <div className="su-card">
                            <div className="su-card-head">
                                <span className="su-step">2</span>
                                <div>
                                    <div className="su-card-title">Register manually</div>
                                    <div className="su-card-desc">Fill in your details to create a new supplier account.</div>
                                </div>
                            </div>
                            <div className="su-grid">
                                <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-first_name">First Name</label>
                                    <div style={{ position: "relative" }}>
                                        <span className="sq-input-icon"><i className="fa-regular fa-user"></i></span>
                                        <input id="sq-first_name" className="sq-input" name="first_name" type="text" value={first_name} placeholder="Enter first name" onChange={changeValue} required />
                                        {error && error.first_name && <span className="cus-err login-err">{error.first_name}</span>}
                                    </div>
                                </div>
                                <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-last_name">Last Name</label>
                                    <div style={{ position: "relative" }}>
                                        <span className="sq-input-icon"><i className="fa-regular fa-user"></i></span>
                                        <input id="sq-last_name" className="sq-input" name="last_name" type="text" value={last_name} placeholder="Enter last name" onChange={changeValue} required />
                                        {error && error.last_name && <span className="cus-err login-err">{error.last_name}</span>}
                                    </div>
                                </div>
                                <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-email">Email</label>
                                    <div style={{ position: "relative" }}>
                                        <span className="sq-input-icon">
                                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </span>
                                        <input id="sq-email" className="sq-input" name="email" type="email" value={email} placeholder="Enter your email" onChange={changeValue} required />
                                        {error && error.email && <span className="cus-err login-err">{error.email}</span>}
                                    </div>
                                </div>
                                <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-phone">Phone</label>
                                    <div>
                                        <IntlTelInput
                                            ref={inputRef}
                                            initialValue={''}
                                            onChangeNumber={(e) => handleNumberChange(e)}
                                            onChangeValidity={(e) => handleValidityChange(e)}
                                            inputClassName="sq-input"
                                            showFlags={true}
                                            initOptions={{
                                                initialCountry: 'PT',
                                                separateDialCode: true,
                                            }}
                                        />
                                        {error && error.country_code && <span className="cus-err mt-1">{error.country_code}</span>}
                                    </div>
                                </div>
                                <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-legal_company_name">Company Name</label>
                                    <div style={{ position: "relative" }}>
                                        <span className="sq-input-icon"><i className="fa-regular fa-building"></i></span>
                                        <input id="sq-legal_company_name" className="sq-input" name="legal_company_name" type="text" value={legal_company_name} placeholder="Enter company name" onChange={changeValue} required />
                                        {error && error.legal_company_name && <span className="cus-err login-err">{error.legal_company_name}</span>}
                                    </div>
                                </div>
                                <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-country">Company Country</label>
                                    <Select2
                                        data={CountrySelectoptions2}
                                        value={selectedCountryOption}
                                        options={{
                                            placeholder: 'Select a country',
                                            escapeMarkup: (markup) => markup,
                                            templateResult: (data) => data.text,
                                            templateSelection: (data) => data.text,
                                        }}
                                        onChange={handleCountrySelectChange}
                                    />
                                    {error && error.company_country && <span className="cus-err">{error.company_country}</span>}
                                </div>
                                <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-provider">Tour booking provider</label>
                                    <div style={{ position: 'relative' }}>
                                        <Select2
                                            data={ProviderSelectoptions2}
                                            value={selectedTourProviderOption}
                                            options={{
                                                placeholder: 'Select your provider',
                                                escapeMarkup: (markup) => markup,
                                                templateResult: (data) => data.text,
                                                templateSelection: (data) => data.text,
                                            }}
                                            onChange={handleTourProviderSelectChange}
                                        />
                                        {error && error.company_tour_provider && <span className="cus-err login-err">{error.company_tour_provider}</span>}
                                    </div>
                                </div>
                                {isOtherProvider && (
                                    <div className="sq-input-wrap">
                                        <label className="sq-label" htmlFor="sq-other_provider_name">Provider Name</label>
                                        <div style={{ position: "relative" }}>
                                            <input id="sq-other_provider_name" className="sq-input no-icon" name="other_provider_name" type="text" value={other_provider_name} placeholder="Enter provider name" onChange={changeValue} required />
                                        </div>
                                    </div>
                                )}
                                {isOtherProvider && (
                                    <small className="text-muted d-block mb-2 su-full">We don't currently support this provider. You can tell us which platform you use, and we'll consider adding support for it.</small>
                                )}
                                {!isOtherProvider && !isNoProvider && <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-password">Password</label>
                                    <div style={{ position: "relative" }}>
                                        <span className="sq-input-icon">
                                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M7 11V7a5 5 0 0110 0v4" />
                                            </svg>
                                        </span>
                                        <input id="sq-password" name="password" className="sq-input" type={!showPassword ? 'password' : 'text'} value={password} placeholder="Enter password" onChange={changeValue} style={{ paddingRight: "2.75rem" }} required />
                                        <button className="sq-pw-toggle" type="button" aria-label="Toggle password">
                                            {
                                                showPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 1)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 1)}></i>
                                            }
                                        </button>
                                        {error && error.password && <span className="cus-err login-err">{error.password}</span>}
                                    </div>
                                </div>}
                                {!isOtherProvider && !isNoProvider && <div className="sq-input-wrap">
                                    <label className="sq-label" htmlFor="sq-cpassword">Confirm Password</label>
                                    <div style={{ position: "relative" }}>
                                        <span className="sq-input-icon">
                                            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M7 11V7a5 5 0 0110 0v4" />
                                            </svg>
                                        </span>
                                        <input id="sq-cpassword" name="cpassword" className="sq-input" type={!showCPassword ? 'password' : 'text'} value={cpassword} placeholder="Confirm password" onChange={changeValue} style={{ paddingRight: "2.75rem" }} />
                                        <button className="sq-pw-toggle" type="button" aria-label="Toggle password">
                                            {
                                                showCPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 0)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 0)}></i>
                                            }
                                        </button>
                                        {error && error.cpassword && <span className="cus-err login-err">{error.cpassword}</span>}
                                    </div>
                                </div>}
                                {!isOtherProvider && !isNoProvider && <div className="lineSpan">
                                    <span className={getClassNames(0)}></span>
                                    <span className={getClassNames(1)}></span>
                                    <span className={getClassNames(2)}></span>
                                </div>}
                            </div>

                            {!isNoProvider && <button className="common-btn sq-btn-primary" type="submit" disabled={isLoading}>
                                {isLoading ? "Loading..." : (isOtherProvider ? "Submit provider request" : "Create account")}
                                {!isLoading && <i className="fa-solid fa-arrow-right"></i>}
                            </button>}
                            {isNoProvider && <small className="text-danger d-block mt-1">A supported tour booking provider is required to use ToursXplorer</small>}
                        </div>
                    </form>}

                    <ProviderRegisterModal provider={registerProvider} onClose={() => setRegisterProvider('')} />

                    <p className="sq-signup-link">Already have an account? <Link to={"/login"}>Login</Link></p>
                </div>
            </div>

            <div className="sq-right">

                <div className="sq-right-content">
                    <h2 className="sq-hero-title">Welcome to the<br /> Supplier Portal</h2>

                    <div className="sq-quote-block">
                    <p className="sq-quote-text">Simplify tour management, monitor real-time reservations, and keep your explorers prepared for their next thrill. Everything you need to organize, grow, and scale your adventure offerings: all in one place.</p>
                    </div>
                </div>

                <div className="sq-logos-section">
                    <div className="sq-logos-divider"></div>
                    <div className="sq-logos-label">We work with</div>
                    <div className="sq-logos-row">
                        <ProviderList />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Index;
